
export default function Footer() {
  return (
    <footer className="bg-black text-yellow-400 py-12 sm:py-16">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
            Cashflow VIP
          </h2>
          <p className="text-lg sm:text-xl text-gray-300">
            Donde los negocios se convierten en oportunidades
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-yellow-400">Servicios Principales</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li>
                <i className="ri-arrow-right-s-fill mr-2"></i>
                Reestructuración de crédito
              </li>
              <li>
                <i className="ri-arrow-right-s-fill mr-2"></i>
                Funding empresarial
              </li>
              <li>
                <i className="ri-arrow-right-s-fill mr-2"></i>
                Creación de corporaciones
              </li>
              <li>
                <i className="ri-arrow-right-s-fill mr-2"></i>
                Mentoría VIP
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-yellow-400">Comunidad</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li className="hover:text-yellow-400 transition-colors cursor-pointer" onClick={() => window.open('https://chat.whatsapp.com/IrHzXCjZBm2DxGCEo8ZoyA?mode=ems_copy_t', '_blank')}>
                <i className="ri-whatsapp-fill mr-2"></i>
                Grupo de WhatsApp
              </li>
              <li>
                <i className="ri-graduation-cap-fill mr-2"></i>
                Plataforma Skool
              </li>
              <li>
                <i className="ri-calendar-event-fill mr-2"></i>
                Eventos exclusivos
              </li>
              <li>
                <i className="ri-team-fill mr-2"></i>
                Red de networking
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-yellow-400">Recursos</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li>
                <i className="ri-book-open-fill mr-2"></i>
                Guías financieras
              </li>
              <li>
                <i className="ri-video-fill mr-2"></i>
                Webinars exclusivos
              </li>
              <li>
                <i className="ri-article-fill mr-2"></i>
                Blog empresarial
              </li>
              <li>
                <i className="ri-question-answer-fill mr-2"></i>
                FAQ
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-yellow-400">Contacto</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li>
                <i className="ri-mail-fill mr-2"></i>
                info@cashflowvip.com
              </li>
              <li>
                <i className="ri-phone-fill mr-2"></i>
                +1 (305) 342-7153
              </li>
              <li>
                <i className="ri-map-pin-fill mr-2"></i>
                Miami, FL
              </li>
              <li>
                <i className="ri-time-fill mr-2"></i>
                Lun-Vie 9AM-6PM
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              © 2025 Cashflow VIP. Todos los derechos reservados.
            </div>
            
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-instagram-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-youtube-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
